<div
  *renderingPermissionDirective="[
    'DeviceMonitoringWriter',
    'DeviceMonitoringReader',
    'DeviceMonitoringAdmin',
  ]"
  class="monitoring">
  <div class="monitoring__content">
    <dcc-page-title title="Profiles"></dcc-page-title>

    <div class="monitoring__header">
      <app-device-monitoring-search
        [isLoading]="loading"
        (clickSearched)="clickSearched($event)"></app-device-monitoring-search>
    </div>

    <div
      *ngIf="error"
      class="alert alert-danger">
      An error has occurred, check devtools console for more info. Contact
      Device Platform team if issues persist.
    </div>

    <div *ngIf="!loading">
      <dcc-timeline
        *ngFor="let data of deviceData | keyvalue"
        class="monitoring__timeline"
        [endDate]="endDate"
        [monitoringData]="data.value"
        [serialNumber]="data.key"
        [startDate]="startDate"></dcc-timeline>
    </div>

    <dcc-spinner *ngIf="loading"></dcc-spinner>
  </div>
</div>
